import { Children, forwardRef } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { breakpoints } from '../../../../constants';

import { Box, Flex } from '../../../grid';

const ScrollWrapper = styled(Flex)`
  display: flex;
  position: relative;
  overflow-x: scroll;
  scroll-behavior: smooth;
  -ms-overflow-style: none;
  scrollbar-width: none;
  flex-direction: ${({ verticalDisplay }) => (verticalDisplay ? 'column' : 'row')};
  padding: 0 16px;
  flex-wrap: nowrap;

  @media (min-width: ${breakpoints.md}) {
    padding: 0 32px;
  }

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const OptionGroup = forwardRef(({ children, isByo, verticalDisplay, ...rest }, ref) => {
  const arrayChildren = Children.toArray(children);

  if (isByo) {
    return (
      <Flex flexDirection="column" px={{ xs: 2, md: 1 }}>
        {children}
      </Flex>
    );
  }

  return (
    <Box position="relative" pt="4px">
      <ScrollWrapper gap="8px" ref={ref} verticalDisplay={verticalDisplay} {...rest}>
        {Children.map(arrayChildren, child => (
          <Box>{child}</Box>
        ))}
      </ScrollWrapper>
    </Box>
  );
});

OptionGroup.propTypes = {
  children: PropTypes.node.isRequired,
  isByo: PropTypes.bool,
  verticalDisplay: PropTypes.bool,
};

OptionGroup.defaultProps = {
  isByo: false,
  verticalDisplay: false,
};
